// Canonical B2B partner categories (must mirror backend core/config.py PARTNER_CATEGORIES).
// French labels (superadmin console + registration form are FR-first).
export const PARTNER_CATEGORY_LABELS_FR = {
  airport: "Aéroport",
  travel_agency: "Agence de voyage",
  bank: "Banque",
  bar_cafe: "Bar / Café",
  library: "Bibliothèque",
  mall: "Centre commercial",
  sports_center: "Centre sportif",
  cinema: "Cinéma",
  airline: "Compagnie aérienne",
  school_university: "École / Université",
  private_company: "Entreprise privée",
  coworking: "Espace de coworking",
  train_bus_station: "Gare ferroviaire / routière",
  hospital_clinic: "Hôpital / Clinique",
  hotel: "Hôtel",
  city_hall: "Mairie / Administration publique",
  museum: "Musée",
  tourism_office: "Office de tourisme",
  amusement_park: "Parc d'attractions",
  pharmacy: "Pharmacie",
  restaurant: "Restaurant",
  concert_theater: "Salle de concert / Théâtre",
  gym_fitness: "Salle de sport / Fitness",
  beauty_salon: "Salon de coiffure / Beauté",
  stadium_arena: "Stade / Arena",
  supermarket: "Supermarché",
  taxi_vtc: "Taxi / VTC",
  public_transport: "Transport en commun",
  // Legacy keys preserved for existing data.
  park: "Parcs",
  prefecture: "Préfectures",
  other: "Autre",
  uncategorized: "Non catégorisé",
};

// Keys sorted alphabetically by French label (used to render the dropdown).
export const PARTNER_CATEGORY_KEYS = Object.keys(PARTNER_CATEGORY_LABELS_FR)
  .filter((k) => k !== "uncategorized")
  .sort((a, b) =>
    PARTNER_CATEGORY_LABELS_FR[a].localeCompare(PARTNER_CATEGORY_LABELS_FR[b], "fr", { sensitivity: "base" }));

// Translate a partner category key using the app t() (falls back to the French label).
export function partnerCategoryLabel(t, key) {
  const k = key || "uncategorized";
  const translated = t ? t(`pcat.${k}`) : null;
  if (translated && translated !== `pcat.${k}`) return translated;
  return PARTNER_CATEGORY_LABELS_FR[k] || PARTNER_CATEGORY_LABELS_FR.uncategorized;
}

// Keyword → category, mirrors backend core/config.py guess_category().
const CATEGORY_KEYWORDS = [
  ["hotel", ["hotel", "hôtel", "hostel", "auberge", "motel", "resort", "lodge", "gîte", "gite"]],
  ["restaurant", ["restaurant", "resto", "brasserie", "bistro", "bistrot", "pizzeria", "cantine", "traiteur"]],
  ["bar_cafe", ["café", "cafe", "bar ", "pub", "salon de thé"]],
  ["supermarket", ["supermarché", "supermarche", "supermarket", "épicerie", "epicerie"]],
  ["mall", ["centre commercial", "galerie marchande", "mall"]],
  ["pharmacy", ["pharmacie", "pharmacy"]],
  ["bank", ["banque", "bank", "crédit", "credit agricole"]],
  ["museum", ["musée", "musee", "museum"]],
  ["cinema", ["cinéma", "cinema"]],
  ["library", ["bibliothèque", "bibliotheque", "médiathèque", "mediatheque"]],
  ["gym_fitness", ["salle de sport", "fitness", "gym", "basic-fit"]],
  ["hospital_clinic", ["hôpital", "hopital", "clinique", "chu", "clinic"]],
  ["airport", ["aéroport", "aeroport", "airport"]],
  ["train_bus_station", ["gare", "station"]],
  ["school_university", ["école", "ecole", "université", "universite", "collège", "lycée", "campus"]],
  ["amusement_park", ["parc d'attraction", "parc d attraction", "disney", "astérix", "asterix"]],
  ["park", ["parc", "park", "jardin", "zoo", "aquarium"]],
  ["city_hall", ["mairie", "hôtel de ville", "hotel de ville", "commune", "city hall", "administration"]],
  ["prefecture", ["préfecture", "prefecture", "sous-préfecture", "sous-prefecture"]],
];

// Best-effort category guess from an establishment name (returns "" if none).
export function guessCategory(name) {
  const n = (name || "").trim().toLowerCase();
  if (!n) return "";
  for (const [cat, kws] of CATEGORY_KEYWORDS) {
    if (kws.some((kw) => n.includes(kw))) return cat;
  }
  return "";
}
